import React from "react";
import PropTypes from "prop-types";
import styles from "./MyLinks.module.css";

const MyLinks = ({ isSignedIn }) => {
  // if (!isSignedIn) return null;
  return (
    <div className={styles.myLinks}>
      <button className={styles.dropdownButton}>
        MY LINKS
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-chevron-down"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M1.5 4.5a.75.75 0 0 1 1.06 0L8 9.94l5.44-5.44a.75.75 0 0 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06z"
            strokeWidth="4"
          />
        </svg>
      </button>

      <div className={styles.dropdownMenu}>
        <div className={styles.linksGroup}>
          <a
            href="https://apps.apple.com/us/app/bidpro-tripboard-for-ipa/id1590630416"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tripboard App
          </a>
          <a
            href="https://apps.apple.com/us/app/bidpro-bidding-for-ipa/id1251050627"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bidding App
          </a>
          <a
            href="https://apps.apple.com/us/app/bidpro-seniority-for-ipa/id1527711444"
            target="_blank"
            rel="noopener noreferrer"
          >
            Seniority App
          </a>
        </div>
        <hr className={styles.divider} />
        <div className={styles.linksGroup}>
          <a
            href="https://tripboard.bidproplus.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Web Tripboard
          </a>
          <a
            href="https://bidding.bidproplus.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Web Bidding
          </a>
        </div>
      </div>
    </div>
  );
};

// MyLinks.propTypes = {
//   isSignedIn: PropTypes.bool.isRequired,
// };

export default MyLinks;
